module.exports = __webpack_public_path__ + "media/images/ilustrations/ilustration-6-01570dd42e4a31e2a21c59215621fcc0.png";